module.exports = __webpack_public_path__ + "img/text-recognition.997b4110.png";